import { rootApi } from 'root-api'

const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    sendEmails: build.mutation({
      query: (formData) => ({
        url: '/api/send_from_calendly/emails',
        method: 'POST',
        data: formData,
      }),
      extraOptions: {
        handleErrors: false
      },
      invalidatesTags: ['Meeting', 'Invitee']
    }),
  })
})

export const {
  useSendEmailsMutation,
} = api
